import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=37d0ab30&scoped=true"
import script from "./quit.vue?vue&type=script&lang=js"
export * from "./quit.vue?vue&type=script&lang=js"
import style0 from "./quit.vue?vue&type=style&index=0&id=37d0ab30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0ab30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d0ab30')) {
      api.createRecord('37d0ab30', component.options)
    } else {
      api.reload('37d0ab30', component.options)
    }
    module.hot.accept("./quit.vue?vue&type=template&id=37d0ab30&scoped=true", function () {
      api.rerender('37d0ab30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesman/staffManage/quit.vue"
export default component.exports